import React, { Component } from "react";

const formatDistance = (distance) => {
  if (!distance) {
    return null;
  }

  return `${Math.round(distance / 1000)} km`;
};

const formatDuration = (duration) => {
  if (!duration) {
    return null;
  }

  const minutes = Math.round(duration / 60);

  if (minutes < 60) {
    return `${minutes} min`;
  }

  return `${Math.floor(minutes / 60)} h ${`${minutes % 60}`.padStart(2, "0")}`;
};

const plural = (count, word) => `${count} ${word}${count > 1 ? "s" : ""}`;

// Compteur d'expertises du périmètre recherché + liste des tournées du jour,
// une ligne par expert. Cliquer sur une ligne n'affiche que cette tournée : au
// niveau réseau il y a jusqu'à 150 tournées le même jour, illisibles ensemble.
export default class TourLegend extends Component {
  render() {
    const { total, tours, selected, onSelect } = this.props;

    const style = {
      container: {
        display: "flex",
        flexDirection: "column",
        height: "900px",
        borderRadius: "10px",
        backgroundColor: "rgb(236, 236, 236)",
        overflow: "hidden",
      },
      header: {
        padding: "10px",
        borderBottom: "1px solid rgb(220, 220, 220)",
      },
      count: {
        margin: 0,
        fontSize: "28px",
        fontWeight: "bold",
        lineHeight: "32px",
      },
      countLabel: {
        margin: 0,
        fontSize: "12px",
        textTransform: "uppercase",
      },
      detail: {
        margin: "6px 0 0 0",
        fontSize: "12px",
        color: "rgb(90, 90, 90)",
      },
      list: {
        flex: 1,
        overflowY: "auto",
      },
      title: {
        margin: 0,
        padding: "10px 10px 6px 10px",
        fontSize: "12px",
        textTransform: "uppercase",
      },
      row: (isSelected) => ({
        display: "flex",
        alignItems: "center",
        width: "100%",
        padding: "6px 10px",
        border: "none",
        borderLeft: `4px solid ${
          isSelected ? "rgb(90, 90, 90)" : "transparent"
        }`,
        backgroundColor: isSelected ? "rgb(222, 222, 222)" : "transparent",
        textAlign: "left",
        cursor: "pointer",
      }),
      dot: (color) => ({
        flex: "0 0 auto",
        width: "12px",
        height: "12px",
        marginRight: "8px",
        borderRadius: "50%",
        backgroundColor: color,
      }),
      name: {
        display: "block",
        fontSize: "13px",
        fontWeight: "bold",
      },
      meta: {
        display: "block",
        fontSize: "11px",
        color: "rgb(90, 90, 90)",
      },
      empty: {
        padding: "10px",
        fontSize: "12px",
        color: "rgb(90, 90, 90)",
      },
    };

    return (
      <div style={style.container}>
        <div style={style.header}>
          <p style={style.count}>{total ? total.expertises : 0}</p>
          <p style={style.countLabel}>
            {total && total.expertises > 1 ? "expertises" : "expertise"}
          </p>
          {total ? (
            <p style={style.detail}>
              {`${total.appointments} rendez-vous`}
              {" · "}
              {plural(total.actions, "passage")} relevé
              {total.actions > 1 ? "s" : ""}
            </p>
          ) : null}
        </div>
        <div style={style.list}>
          <p style={style.title}>Tournées</p>
          {tours.length ? (
            <>
              <button
                type="button"
                style={style.row(!selected)}
                onClick={() => onSelect(null)}
              >
                <span style={style.dot("rgb(150, 150, 150)")} />
                <span>
                  <span style={style.name}>Toutes les tournées</span>
                  <span style={style.meta}>
                    {plural(tours.length, "expert")}
                  </span>
                </span>
              </button>
              {tours.map((tour) => {
                const isSelected = selected === tour.id;
                const distance = formatDistance(tour.distance);
                const duration = formatDuration(tour.duration);

                return (
                  <button
                    key={tour.id}
                    type="button"
                    style={style.row(isSelected)}
                    onClick={() => onSelect(isSelected ? null : tour.id)}
                  >
                    <span style={style.dot(tour.color)} />
                    <span>
                      <span style={style.name}>
                        {tour.expert || "Expert inconnu"}
                      </span>
                      <span style={style.meta}>
                        {[
                          plural(tour.stops, "étape"),
                          plural(tour.expertises, "expertise"),
                          distance,
                          duration,
                        ]
                          .filter(Boolean)
                          .join(" · ")}
                      </span>
                    </span>
                  </button>
                );
              })}
            </>
          ) : (
            <p style={style.empty}>
              Aucune tournée à afficher : il faut au moins deux rendez-vous
              géolocalisés pour tracer l'itinéraire d'un expert.
            </p>
          )}
        </div>
      </div>
    );
  }
}
